// extracted by mini-css-extract-plugin
module.exports = {"dots":"_2XqGydJ","dot":"_38sz-ek","active":"_1R_ffq9"};